const RANDOM_CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

const getRandomId = (length: number) => {
    let result = "";
    for (let i = 0; i < length; i++) {
        result += RANDOM_CHARACTERS.charAt(Math.floor(Math.random() * RANDOM_CHARACTERS.length));
    }
    return result;
};

export const getClientId = () => {
    const savedUserKey = localStorage.getItem("conversation_maker_client_key");

    if (savedUserKey) {
        return savedUserKey;
    }
    const randomHashValue = getRandomId(32);
    localStorage.setItem("conversation_maker_client_key", randomHashValue);
    return randomHashValue;
};

export const isTextTruncated = (element: HTMLElement) => {
    const range = document.createRange();
    range.selectNodeContents(element);
    const textWidth = range.getBoundingClientRect().width;
    const elementWidth = element.getBoundingClientRect().width;

    return textWidth > elementWidth;
};

export const isTextLineClamped = (element: HTMLElement) => {
    return element.scrollHeight > element.clientHeight;
};

const CJK_REGEXP = /[가-힣ㄱ-ㅎㅏ-ㅣ一-龥]/;
export const isCJKCharacter = (text: string) => {
    return CJK_REGEXP.test(text);
};

const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;;
export const isEmail = (email: string) => {
    return EMAIL_REGEXP.test(email);
};

export const isUrl = (url: string) => {
    if (url.includes(" ")) {
        return false;
    }
    try {
        const { protocol, hostname } = new URL(url);
        return !!hostname && (protocol === "http:" || protocol === "https:");
    } catch {
        return false;
    }
};

export const isBlobUrl = (url: string) => {
    if (url.includes(" ")) {
        return false;
    }
    try {
        const { protocol } = new URL(url);
        return protocol === "blob:";
    } catch {
        return false;
    }
};

export const escapeCondition = (condition?: string): string | undefined => {
    if (!condition) {
        return;
    }
    const regExp = /[{}[\]/?.,;:|)*~`!^\-_+<>@#$%&\\=('"]/;
    return condition.split(' ').reduce((c, v) => {
        const prev_con = c ? (c + ' ') : '';
        // eslint-disable-next-line no-useless-escape
        return !!v.match(regExp) ? prev_con + `\"${v}\"` : prev_con + v;
    }, "");
};

export const isValidJSON = (value: string): boolean => {
    try {
        JSON.parse(value);
        return true;
    } catch {
        return false;
    }
};

export const formatJSON = (json: object | string | undefined): string => {
    switch (typeof json) {
        case "undefined":
            return "{}";
        case "string":
            try {
                return JSON.stringify(JSON.parse(json), undefined, 4);
            } catch (e) {
                return json;
            }
        case "object":
            return JSON.stringify(json, undefined, 4);
        default:
            return "{}";
    }
};

export const toTitleCase = (str: string) => {
    return str
        .toLowerCase()
        .split(' ')
        .map(word => 
            word ? word.charAt(0).toUpperCase() + word.slice(1) : word
        )
        .join(' ');
};

export const deployVersion = (version: string) => {
    return `v ${version.padStart(3, '0')}`;
};
